'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColoring = undefined;

var _reselect = require('reselect');

var _WidgetDataModel = require('conversations-schema/models/WidgetDataModel');

var WidgetDataModel = _interopRequireWildcard(_WidgetDataModel);

var _getLatestWidgetData = require('../../widget-data/selectors/getLatestWidgetData');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getColoring = exports.getColoring = (0, _reselect.createSelector)(_getLatestWidgetData.getLatestWidgetData, WidgetDataModel.getColoring);